"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _map2 = _interopRequireDefault(require("lodash/map"));

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _TextLabel = _interopRequireDefault(require("../Typography/TextLabel"));

var _ChevronLeftIcon = _interopRequireDefault(require("../Icons/ChevronLeftIcon"));

var _ChevronRightIcon = _interopRequireDefault(require("../Icons/ChevronRightIcon"));

var _VerticalSeparator = _interopRequireDefault(require("../Separator/VerticalSeparator"));

var _Select = _interopRequireDefault(require("../Select/Select"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Pagination component mostly used on tables.
 */
var Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_this));

    var _this$props = _this.props,
        pageSize = _this$props.pageSize,
        pageSizeOptions = _this$props.pageSizeOptions;
    var newPageSize;

    if (_this.isPageSizeOptions()) {
      _this.hasOptions = true;
      newPageSize = pageSizeOptions.indexOf(pageSize) > -1 ? pageSize : pageSizeOptions[0];
    } else {
      newPageSize = pageSize || 10;
    }

    _this.checkCurrentPageIsValid(props, newPageSize);

    _this.state = {
      current: _this.props.currentPage,
      pageSize: newPageSize
    };
    return _this;
  }

  _createClass(Pagination, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.checkCurrentPageIsValid(nextProps, nextProps.pageSize);

      if (nextProps.currentPage !== this.props.currentPage) {
        this.setState({
          current: nextProps.currentPage
        });
      }

      if (nextProps.pageSize !== this.props.pageSize) {
        this.setState({
          pageSize: nextProps.pageSize
        });
      }
    }
    /**
     * Check if the props passed in is valid.  Throw an exception if it is not
     * valid.
     * @param {object} props - See PropTypes.
     * @param {number} pageSize - page size.
     */

  }, {
    key: "checkCurrentPageIsValid",
    value: function checkCurrentPageIsValid(props, pageSize) {
      var total = this.props.total;

      if (props.currentPage > this.totalPage(total, pageSize) || props.currentPage < 1) {
        throw new Error('Pagination: Invalid currentPage passed');
      }
    }
    /**
     * @returns {boolean} true if there are page size options
     */

  }, {
    key: "isPageSizeOptions",
    value: function isPageSizeOptions() {
      var pageSizeOptions = this.props.pageSizeOptions;
      return pageSizeOptions && pageSizeOptions.length;
    }
    /**
     *  Check is there is a previous page.
     *
     *  @returns {boolean} is there a previous.
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          showOnlyPage = _this$props2.showOnlyPage,
          total = _this$props2.total,
          disabled = _this$props2.disabled,
          pageSizeOptions = _this$props2.pageSizeOptions,
          prevProps = _this$props2.prevProps,
          nextProps = _this$props2.nextProps,
          wrapperProps = _this$props2.wrapperProps,
          pageSizeOptionLabel = _this$props2.pageSizeOptionLabel,
          pageSizeOptionsProps = _this$props2.pageSizeOptionsProps;
      var pageSize = this.state.pageSize;
      var paginators;

      if (showOnlyPage) {
        var totalPage = this.totalPage(this.props.total, pageSize);

        var pageOnlyText = _I18nManager.default.t('Pagination', 'page_only').replace('%(page)', this._formatNumber(this.state.current)).replace('%(total)', this._formatNumber(totalPage));

        paginators = _react.default.createElement(_TextLabel.default, {
          type: "secondary"
        }, pageOnlyText);
      } else {
        var offset = (this.state.current - 1) * pageSize + 1;
        var endOffset = offset + pageSize - 1 < total ? offset + pageSize - 1 : total;

        var text = _I18nManager.default.t('Pagination', 'range').replace('%(start)', this._formatNumber(offset)).replace('%(end)', this._formatNumber(endOffset)).replace('%(total)', this._formatNumber(total));

        paginators = _react.default.createElement(_TextLabel.default, {
          type: "secondary"
        }, text);
      }

      var isPrevDisabled = disabled || !this.hasPrev();
      var isNextDisabled = disabled || !this.hasNext();
      var prevButtonType = isPrevDisabled ? 'secondary' : 'primary';
      var nextButtonType = isNextDisabled ? 'secondary' : 'primary'; // Map and format option to match Selce

      var currentOption, selectOptions;

      if (this.isPageSizeOptions()) {
        currentOption = (0, _findIndex2.default)(pageSizeOptions, function (option) {
          return option === pageSize;
        });
        selectOptions = (0, _map2.default)(pageSizeOptions, function (option, i) {
          return {
            key: option,
            label: "".concat(option, " ").concat(pageSizeOptionLabel)
          };
        });
      }

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)("".concat(clsPrfx, " ").concat(clsPrfx, "-pagination"), className),
        alignItems: "center",
        itemSpacing: "10px"
      }, wrapperProps), _react.default.createElement(_Button.default, _extends({
        appearance: "mini",
        disabled: isPrevDisabled,
        type: prevButtonType,
        onClick: this.prev
      }, prevProps), _react.default.createElement(_ChevronLeftIcon.default, null)), paginators, _react.default.createElement(_Button.default, _extends({
        appearance: "mini",
        onClick: this.next,
        disabled: isNextDisabled,
        type: nextButtonType
      }, nextProps), _react.default.createElement(_ChevronRightIcon.default, null)), this.hasOptions && _react.default.createElement(_FlexLayout.default, {
        itemSpacing: "10px",
        alignItems: "center"
      }, _react.default.createElement(_VerticalSeparator.default, null), _react.default.createElement(_Select.default, _extends({
        inputProps: {
          disabled: disabled
        },
        selectedRow: this.isPageSizeOptions() && selectOptions[currentOption],
        rowsData: selectOptions,
        autoSize: true,
        type: "mini",
        onSelectedChange: this.handlePageSizeChange
      }, pageSizeOptionsProps))));
    }
    /**
     * Format number for display
     * @param {number} number - Number to be formatted
     * @returns {string} - Formatted number
     * @private
     */

  }, {
    key: "_formatNumber",
    value: function _formatNumber(number) {
      var formattedNumber;

      if (this.props.formatNumber) {
        formattedNumber = this.props.formatNumber(number);
      } else {
        formattedNumber = _I18nManager.default.formatNumber(number);
      }

      return formattedNumber;
    }
  }]);

  return Pagination;
}(_react.default.Component);

exports.default = Pagination;

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.hasPrev = function () {
    return _this2.state.current > 1;
  };

  this.totalPage = function (total, pageSize) {
    return Math.ceil(total / pageSize);
  };

  this.hasNext = function () {
    var _this2$state = _this2.state,
        current = _this2$state.current,
        pageSize = _this2$state.pageSize;
    return current < _this2.totalPage(_this2.props.total, pageSize);
  };

  this.prev = function () {
    _this2.handleChange(_this2.state.current - 1);
  };

  this.handleChange = function (page) {
    var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.state.pageSize;

    var pageHasChanged = page !== _this2.state.current && page >= 1 && page <= _this2.totalPage(_this2.props.total, pageSize);

    var pageSizeHasChanged = pageSize !== _this2.state.pageSize;

    if (pageHasChanged || pageSizeHasChanged) {
      if (_this2.props.onChange) {
        _this2.props.onChange(page, pageSize);
      } else {
        _this2.setState({
          current: page,
          pageSize: pageSize
        });
      }
    }
  };

  this.handlePageSizeChange = function (selectedOption) {
    var firstRow = (_this2.state.current - 1) * _this2.state.pageSize + 1;
    var newPageSize = selectedOption.key;
    var newCurrentPage = Math.ceil(firstRow / newPageSize);

    _this2.handleChange(newCurrentPage, newPageSize);
  };

  this.next = function () {
    _this2.handleChange(_this2.state.current + 1);
  };
};

Pagination.defaultProps = {
  showOnlyPage: false,
  currentPage: 1,
  pageSizeOptionLabel: _I18nManager.default.t('Pagination', 'default_page_size_option_label')
};
Pagination.propTypes = {
  /**
   * Customize classname.
   */
  className: _propTypes.default.string,

  /**
   * Show only the page count.
   */
  showOnlyPage: _propTypes.default.bool,

  /**
   * Triggered when the page changes with the new page number.
   * currentPage and pageSize are passed as argument to the callback.
   * onChange(currentPage, pageSize)
   */
  onChange: _propTypes.default.func,

  /**
   * Total number of items.
   */
  total: _propTypes.default.number.isRequired,

  /**
   * Number of items per page.
   * If pageSize and pageSizeOptions are unset pageSize will fallback to 10
   */
  pageSize: _propTypes.default.number,

  /**
   * Array of options for Page Sizes (select).
   * If pageSizeOptions is set and pageSize is unset the first element
   * in the pageSizeOptions Array will be used as default size
   */
  pageSizeOptions: _propTypes.default.arrayOf(_propTypes.default.number),

  /**
   * Current page number.
   */
  currentPage: _propTypes.default.number,

  /**
   * Disable pagination
   */
  disabled: _propTypes.default.bool,

  /**
   * Override the default label used for page size options
   */
  pageSizeOptionLabel: _propTypes.default.string,

  /**
   * Custom number formatting. By default the numbers are formatted based on
   * the locale set in I18nManager
   * @param {number} number - Number to be formatted
   * @returns {string} - Formatted number
   */
  formatNumber: _propTypes.default.func,

  /**
   * Props to pass to previous button
   */
  prevProps: _propTypes.default.object,

  /**
   * Props to pass to next button
   */
  nextProps: _propTypes.default.object,

  /**
   * Props to pass to page size options select
   */
  pageSizeOptionsProps: _propTypes.default.object,

  /**
   * Props to be passed to wrapping dom element
   */
  wrapperProps: _propTypes.default.object
};